<template>
  <v-menu v-model="menu" :close-on-content-click="false" transition="fade-transition" offset-y>

    <template v-slot:activator="{ on }">
      <v-text-field v-model="c_label" v-on="on" class="ma-1" prepend-inner-icon="mdi-calendar" label="Durată" dense outlined readonly hide-details/>
    </template>

    <v-card tile flat class="pa-2">
      <im-date-picker v-model="c_value" mode='range' locale="ro" is-inline style="border-width: 0" :columns="2"/>
    </v-card>

  </v-menu>
</template>


<script>
  export default {

    props: {
      from: null,
      until: null,
    },

    data: () => ({
      menu: false
    }),

    computed: {
      c_value: {
        get() {
          return {
            start: new Date(this.from),
            end: new Date(this.until)
          };
        },
        set(val) {
          this.$emit("update:from", this.$moment(val.start).format('YYYY-MM-DD'));
          this.$emit("update:until", this.$moment(val.end).format('YYYY-MM-DD'));
        }
      },
      c_label: function () {
        this.menu = false;
        return this.$moment(this.c_value.start).format('DD MMM YYYY') + ' ➞ ' + this.$moment(this.c_value.end).format('DD MMM YYYY')
      }
    }

  }
</script>